"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFireplace = function SvgFireplace(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.534 18.644C8.216 18.038 8 17.4 8 16.606c0-1.387.437-2.125.846-2.642.408-.517.854-1.057.988-2.2.677.318 1.56.975 1.872 1.63-.106-.278-.343-.479-.497-.688-.61-.826.982-1.47.096-3.706 2.998.181 3.736 4.373 3.69 4.88-.061.686-.163.838-.47 1.291.683-.904.823-2.2.823-2.877.999.838 1.696 2.113 1.496 4.306-.221 2.416-1.785 3.906-4.218 3.906s-3.355-.458-4.092-1.862z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20.5h13V14a6.5 6.5 0 1 0-13 0v6.5zm-3-17h19v2h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5h17v15h-17z"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFireplace);
var _default = Memo;
exports["default"] = _default;